import { BaseAPIRequestFactory, RequiredError } from './baseapi.js';
import { HttpMethod, HttpInfo } from '../http/http.js';
import { ObjectSerializer } from '../models/ObjectSerializer.js';
import { ApiException } from './exception.js';
import { isCodeInRange } from '../util.js';
async function deserializeResponseBody(response, dataType, dataFormat) {
    return ObjectSerializer.deserialize(await response.body.json(), dataType, dataFormat);
}
async function deserializeErrorBodyOrFallback(response, dataType, dataFormat) {
    try {
        return await deserializeResponseBody(response, dataType, dataFormat);
    }
    catch {
        return await response.getBodyAsAny();
    }
}
export class FileExplorerListPathApiRequestFactory extends BaseAPIRequestFactory {
    async fileExplorerListPath(projectId, resourceId, prefix, pageSize, pageToken, queryExecutionId, securityAlertedOnly, snapshotId, sortField, sortDir, includeSubtreeSize, includeTotalCount, directoryTree, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("FileExplorerListPathApi", "fileExplorerListPath", "projectId");
        }
        if (resourceId === null || resourceId === undefined) {
            throw new RequiredError("FileExplorerListPathApi", "fileExplorerListPath", "resourceId");
        }
        const localVarPath = '/projects/{projectId}/explorer/{resourceId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'resourceId' + '}', encodeURIComponent(String(resourceId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (prefix !== undefined) {
            requestContext.setQueryParam("prefix", ObjectSerializer.serialize(prefix, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (queryExecutionId !== undefined) {
            requestContext.setQueryParam("queryExecutionId", ObjectSerializer.serialize(queryExecutionId, "string", "tobedefined"));
        }
        if (securityAlertedOnly !== undefined) {
            requestContext.setQueryParam("securityAlertedOnly", ObjectSerializer.serialize(securityAlertedOnly, "boolean", ""));
        }
        if (snapshotId !== undefined) {
            requestContext.setQueryParam("snapshotId", ObjectSerializer.serialize(snapshotId, "string", "uuid"));
        }
        if (sortField !== undefined) {
            requestContext.setQueryParam("sortField", ObjectSerializer.serialize(sortField, "string", "tobedefined"));
        }
        if (sortDir !== undefined) {
            requestContext.setQueryParam("sortDir", ObjectSerializer.serialize(sortDir, "string", "tobedefined"));
        }
        if (includeSubtreeSize !== undefined) {
            requestContext.setQueryParam("includeSubtreeSize", ObjectSerializer.serialize(includeSubtreeSize, "boolean", ""));
        }
        if (includeTotalCount !== undefined) {
            requestContext.setQueryParam("includeTotalCount", ObjectSerializer.serialize(includeTotalCount, "boolean", ""));
        }
        if (directoryTree !== undefined) {
            requestContext.setQueryParam("directoryTree", ObjectSerializer.serialize(directoryTree, "boolean", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class FileExplorerListPathApiResponseProcessor {
    async fileExplorerListPathWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "FileExplorerResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
